/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TooltipModule} from '../tooltip/tooltip.module';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ContextMenuComponent} from './context-menu.component';


@NgModule({
    declarations: [ContextMenuComponent],
    imports: [
        CommonModule,
        TooltipModule,
        NgbDropdownModule,
    ],
    exports: [ContextMenuComponent]
})

export class ContextMenuModule {
}
